export default __webpack_public_path__ + "static/media/Watermelon-Cherry-Quartz-Beaded-Diffuser-Stretch-Bracelet.09441d31.jpg";